export default __webpack_public_path__ + "static/media/21.75aae23c.gif";